export const environment = {
  baseUrl: "https://cf.cuanki.my.id",
  apiKey: "deg43sx4f4cs9fi4k"
};
